'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterpriseContent = function EnterpriseContent(_ref) {
  var children = _ref.children,
      className = _ref.className;

  var styles = require('./EnterpriseContent.scss');

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(className, styles.root) },
    children
  );
};

EnterpriseContent.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
};

exports.default = EnterpriseContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseContent/EnterpriseContent.jsx
// module id = 1582
// module chunks = 0